module.exports = __webpack_public_path__ + "img/facade-1.20dcccb0.jpg";